import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import _ from "lodash";
import { assetsPath } from "../utils";

const noImage = `${assetsPath(
  "phuket-laguna-village-residences"
)}/images/No_Image_Available.jpg`;

const BackgroundImageStyle = styled.div`
  height: 100%;
  background-position: ${props => props.position};
  background-repeat: ${props => props.repeat};
  background-size: ${props => props.size};
  ${props => {
    if (props.responsive) {
      if (props.sm) {
        return `
          @media (max-width: 540px) {
            background-image: url('${props.sm}');
          }
        `;
      }
      if (props.md) {
        return `
          @media (min-width: 541px) and (max-width: 720px) {
            background-image: url('${props.md}');
          }
        `;
      }
      if (props.lg) {
        return `
          @media (min-width: 721px) and (max-width: 960px) {
            background-image: url('${props.md}');
          }
        `;
      }
      if (props.xl) {
        return `
          @media (min-width: 961px) and (max-width: 1326px) {
            background-image: url('${props.md}');
          }
        `;
      }
      if (!props.sm && !props.md && !props.lg && !props.xl) {
        return `
          background-image: url('${props.image}');
        `;
      } else {
        return `
          @media (min-width: 1327px) {
            background-image: url('${props.image}');
          }
        `;
      }
    } else {
      return `
        background-image: url('${props.image}');
      `;
    }
  }};
`;

export default class BackgroundImage extends Component {
  static propTypes = {
    className: PropTypes.string,
    image: PropTypes.string,
    position: PropTypes.string,
    repeat: PropTypes.string,
    size: PropTypes.string,
    children: PropTypes.node
  };

  static defaultProps = {
    className: "",
    image: noImage,
    position: "center",
    repeat: "no-repeat",
    size: "cover",
    children: null
  };

  shouldComponentUpdate(nextProps) {
    const fieldToCheck = [
      "className",
      "image",
      "position",
      "repeat",
      "size",
      "style",
      "children"
    ];
    const _nextProps = _.pick(nextProps, fieldToCheck);
    const _thisProps = _.pick(this.props, fieldToCheck);
    return !_.isEqual(_nextProps, _thisProps);
  }

  render() {
    const { image, children } = this.props;
    return (
      <BackgroundImageStyle {...this.props} image={image || noImage}>
        {children}
      </BackgroundImageStyle>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BackgroundImage.js